import { recipe } from "@vanilla-extract/recipes";

import { theme } from "../../theme/css/theme.css";

export const popupStyle = recipe({
  base: {
    pointerEvents: "auto",
    overflow: "hidden",
    width: "max-content",
    ":focus-visible": {
      outline: `2px solid ${theme.colors.info}`,
      outlineOffset: "2px",
    },
  },
  variants: {
    variant: {
      default: {
        backgroundColor: theme.colors.background,
        color: theme.colors.onBackground,
        border: `1px solid ${theme.colors.defaultBorder}`,
      },
      toggle: {
        backgroundColor: theme.colors.background,
        color: theme.colors.onBackground,
      },
    },
    size: {
      default: {
        borderRadius: theme.borderRadiuses.onXS,
        padding: theme.spacings.xs,
      },
      m: {
        borderRadius: theme.borderRadiuses.onXS,
        padding: theme.spacings.s,
      },
      minimal: {
        borderRadius: theme.borderRadiuses.onXS,
      },
    },
  },
  defaultVariants: {
    variant: "default",
    size: "default",
  },
});
